import { useContext, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import CustomToggle from "../../../helperComponents/CustomToggle";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskNameAndGenderPage() {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();
  const [gender, setGender] = useState("MALE");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loading, setLoading] = useState(false);

  return (
    <OnboardingBoilerplate
      title={t("onboardingNameGenderTitle")}
      desc={t("onboardingNameGenderDesc")}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <CustomToggle options={options} value={gender} onChange={setGender} />

        <MaterialInput
          label={t("onboardingFirstNameInput")}
          value={firstName}
          onChange={extractEventValue(setFirstName)}
        />

        <MaterialInput
          label={t("onboardingLastNameInput")}
          value={lastName}
          onChange={extractEventValue(setLastName)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!firstName) return window.popupAlert(t("onboardingNameGenderWarning"));
    if (firstName.length < 4)
      return window.popupAlert("Name should be at least 4 letters");

    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { gender, firstName, lastName },
      });
      setLoading(false);
      let newLoggedInUser = { ...loggedInUser, firstName, lastName, gender };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
